/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';

import { Button, Image } from 'semantic-ui-react';

import courseDefault from '../img/default-course.svg';

import '../css/BookImageCard.less';

import { SatCoreRegister } from '../SatCoreRegistry';

import { CONTENT_ITEM_TYPES } from '../managers/ContentManager';

import ImageService from '../services/ImageService';
import UtilityService from '../services/UtilityService';

import { stripHtmlTags } from '../utils';

export default class BookImageCard extends Component {
  render() {
    const { course, customDefaultCardImg, showBook, disabled } = this.props;
    const courseName = course.friendlyName || course.name;
    const nameObj = UtilityService.reactHtmlParserWrapper(courseName);
    const imageAltText = ImageService.getContentImageAltText({
      imageAltText: course?.imageUrl ? course.altText : '',
      courseElementName: courseName
    });
    let image = null;

    if (course?.imageUrl) {
      image = <Image alt={imageAltText} fluid src={CONTENT_ITEM_TYPES.getContentImageUrl(course.imageUrl)} />;
    } else if (customDefaultCardImg) {
      image = <Image alt={imageAltText} fluid src={customDefaultCardImg} />;
    }
    return (
      <div className={`book-card-container${disabled ? ' disabled' : ''}`}>
        <div className={`course-card-image ${!image ? 'default-image' : ''}`}>
          {!image ? <Image alt={imageAltText} src={courseDefault} /> : image}
        </div>
        <div className='course-name'>
          <span title={nameObj.stripped}>
            {nameObj.parsed}
          </span>
        </div>
        <div className='actions'>
          <Button
            aria-label={`Open ${stripHtmlTags(courseName)}`}
            className='open-course-button'
            disabled={disabled}
            onClick={() => showBook(course.id)}
            primary
            tabIndex={-1}
            type='button'>
            Open
          </Button>
        </div>
      </div>
    );
  }
}

SatCoreRegister('BookImageCard', BookImageCard);
